import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme, webDarkTheme, } from "@fluentui/react-components";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient()

/* global document, Office, module, require, HTMLElement */

const title = "Sniff and Detect Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;
const isDarkMode = window.matchMedia?.('(prefers-color-scheme: dark)').matches;

/* Render application after Office initializes */
Office.onReady(() => {
    root?.render(
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <FluentProvider theme={isDarkMode ? webDarkTheme : webLightTheme}>
                    <App title={title} />
                </FluentProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
});

// if ((module as any).hot) {
//     (module as any).hot.accept("./App", () => {
//         const NextApp = require("./App").default;
//         root?.render(NextApp);
//     });
// }
